import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';

export default function Logo({
  light = false,
  isIconOnly = false,
  width = 40,
  height = 40,
  fontSize = 19,
  iconStyle,
  textStyle,
}) {
  const { file } = useStaticQuery(graphql`
    query LogoQuery {
      file(relativePath: { eq: "logo-icon.svg" }) {
        publicURL
      }
    }
  `);

  const icon = (
    <img
      src={file.publicURL}
      alt="CredInTech"
      width={width}
      height={height}
      style={{ display: 'block', ...iconStyle }}
    />
  );

  if (isIconOnly) {
    return (
      <Link
        to="/"
        component="div"
        aria-label="CredInTech"
        style={{
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
          ...(light && {
            background: '#fff',
            borderRadius: 8,
            padding: 6,
          }),
        }}
      >
        {icon}
      </Link>
    );
  }

  return (
    <Link
      to="/"
      component="div"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 9,
        textDecoration: 'none',
        width: 'fit-content',
        ...(light && {
          background: '#fff',
          borderRadius: 8,
          padding: '2px 12px 2px 8px',
        }),
      }}
    >
      {icon}
      <span
        style={{
          fontFamily: "'Poppins', 'Manrope', sans-serif",
          fontWeight: 400,
          fontSize,
          letterSpacing: '-0.01em',
          lineHeight: 1,
          display: 'flex',
          alignItems: 'center',
          color: light ? '#0F172A' : '#0F172A',
          ...textStyle,
        }}
      >
        Credin
        <span style={{ color: '#2563EB' }}>Tech</span>
      </span>
    </Link>
  );
}
